// extracted by mini-css-extract-plugin
export default {"targetquestion":"TargetQuestionSection_targetquestion__YMr-n","row":"TargetQuestionSection_row__mDqNN"};